import { Component, EventEmitter, Input, Output, ViewEncapsulation, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormioCustomComponent } from 'dp-formio';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-number-counter-wrapper',
    templateUrl: './number-counter-wrapper.component.html',
    // styleUrls: ['./number-counter-wrapper.component.scss']
    encapsulation: ViewEncapsulation.None
})
export class NumberCounterWrapperComponent implements FormioCustomComponent<any>, OnDestroy, OnChanges {
    dir: 'rtl' | 'ltr';
    @Input() required: boolean;
    @Input() value: any = {};
    @Output() valueChange = new EventEmitter<any>();
    @Input() disabled: boolean;
    @Input() viewOnly: boolean;
    @Input() data: any;
    @Input() customOptions: any;
    @Input() formioComponent: any;
    private subs: Subscription[] = [];
    set sub(s: Subscription) { this.subs.push(s); }

    counter = 0;

    constructor(private translateService: TranslateService) {
        this.changeDirection(this.translateService.currentLang);
        this.sub = this.translateService.onLangChange.subscribe(data => {
            this.changeDirection(data.lang);
        });
    }
    ngOnChanges(changes: SimpleChanges) {
        if (this.customOptions) {
            this.counter = this.value || this.customOptions.default || 0;
            this.notifyValue();
        }
    }

    notifyValue() {
        if (this.required) {
            if (
                (this.customOptions.min != null && this.counter < this.customOptions.min) ||
                (this.customOptions.max != null && this.counter > this.customOptions.max)
            ) {
                this.value = null;
                this.valueChange.emit(this.value);
                return;
            }
        }

        this.value = this.counter;
        this.valueChange.emit(this.value);
    }

    changeValue() {
        if (this.customOptions?.enableUserEntry &&
            (this.counter < this.customOptions.min || this.counter > this.customOptions.max)) {
            this.counter = this.customOptions.default || 0;
            this.notifyValue();
        }
    }

    minus() {
        if (this.counter - (this.customOptions.step || 1) >= this.customOptions.min) {
            this.counter = this.counter - (this.customOptions.step || 1);
            this.notifyValue();
        }
    }
    add() {
        if (this.counter + (this.customOptions.step || 1) <= this.customOptions.max) {
            this.counter = this.counter + (this.customOptions.step || 1);
            this.notifyValue();
        }
    }

    private changeDirection(lang) {
        this.dir = null;
        setTimeout(() => { this.dir = lang === 'ar' ? 'rtl' : 'ltr'; });
    }
    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
        this.subs = [];
    }

}
